import axios from 'axios';

export default () => axios.create({
  baseURL: 'https://api.sensors.blebox.eu/api/air',
  withCredentials: false,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
});
